var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"crossword",attrs:{"id":"crossword"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }